import { useEffect, useState } from "react";

import Image from "next/image";
import Link from "next/link";
import Pagination from "../Common/Pagination";
import { DateTime } from 'luxon';
import GoogleAdLarge from "../Ads/GoogleAdLarge";

const Events = ({
  dataList,
  parentClass,
  childClass,
  isPagination,
  start,
  end,
  userAction
}) => {
  const ITEMS_PER_PAGE = 9;
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const startIndex = (page - 1) * ITEMS_PER_PAGE;

  const getSelectedEvent = events.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handleClick = (num) => {
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setEvents(dataList);
    setTotalPages(Math.ceil(dataList.length / ITEMS_PER_PAGE));
  }, [setTotalPages, setEvents]);

  return (
    <>
      <div className="row g-5">
        {getSelectedEvent.slice(start, end).map((data, index) => (
          <div className={`${childClass}`} key={index}>
            <div className={`rbt-card ${parentClass} variation-01 rbt-hover`}>
              <div className="rbt-card-img">
                <Link href={`event/${data.content_id}`}>
                  <Image
                    src={data.image.thumbnail}
                    width={355}
                    height={240}
                    priority
                    alt="Card image"
                  />
                  {data.status != "past-event" &&
                    <div className="rbt-badge-3 bg-white">
                      <span>{DateTime.fromISO(data.date.start).toFormat("d MMM")}</span>
                      <span>{DateTime.fromISO(data.date.start).toFormat("yyyy")}</span>
                    </div>
                  }
                </Link>
              </div>
              <div className="rbt-card-body">
                <ul className="rbt-meta">
                  {data.status != "past-event" &&
                    <li>
                      <i className="feather-map-pin"></i>
                      {data.location.name}
                    </li>
                  }
                  {data.status == "past-event" &&
                    <li>
                      <i className="feather-clock"></i>
                      {DateTime.fromISO(data.date.start).toFormat("MMM d, yyyy")}
                    </li>
                  }
                  {data.status != "past-event" &&
                    <li>
                      <i className="feather-clock"></i>
                      {data.time}
                    </li>
                  }
                </ul>
                <h4 className="rbt-card-title">
                  <Link href={`event/${data.content_id}`}>{data.title}</Link>
                </h4>

                <div className="read-more-btn">
                  <Link
                    className="rbt-btn btn-border hover-icon-reverse btn-sm radius-round"
                    href={`event/${data.content_id}`}
                  >
                    <span className="icon-reverse-wrapper">
                      <span className="btn-text">Explore</span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                      <span className="btn-icon">
                        <i className="feather-arrow-right"></i>
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
        <GoogleAdLarge />
      </div>

      {isPagination ? (
        <div className="row">
          <div className="col-lg-12 mt--60">
            <Pagination
              totalPages={totalPages}
              pageNumber={page}
              handleClick={handleClick}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Events;
